<!-- 倒计时、计时器 -->
<template>
  <span v-if="min > 0 || sec > 0">{{ min }}分{{ sec }}秒</span>
</template>

<script>
export default {
  props: {
    times: {
      type: Number,
      default: 0
    },
    isReturn: {
      // 返回当前时间
      type: Boolean,
      default: false
    },
    matchEndFlag: {
      // 比赛结束
      type: Boolean,
      default: false
    },
    timerFlag: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      timer: null, // 定时器
      day: "00",
      hou: "00",
      min: "00",
      sec: "00"
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    countDown(time) {
      // 倒计时
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        if (time > 0) {
          // 获取天、时、分、秒
          let day = parseInt(time / (60 * 60 * 24));
          let hou = parseInt((time % (60 * 60 * 24)) / 3600);
          let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
          let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
          this.day = this._zeroFill(day);
          this.hou = this._zeroFill(hou);
          this.min = this._zeroFill(min);
          this.sec = this._zeroFill(sec);
          time--;
        } else {
          // 倒计时已结束，全部设置为'00'
          this.day = "00";
          this.hou = "00";
          this.min = "00";
          this.sec = "00";
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    timeShow(time) {
      // 时间展示
      let min = 0;
      let sec = 0;
      if (time < 60) {
        min = 0;
        sec = time;
      }
      if (time >= 60) {
        min = parseInt(time / 60);
        sec = time - min * 60;
      }
      this.min = this._zeroFill(min);
      this.sec = this._zeroFill(sec);
    },
    clock(time) {
      // 计时器
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        time++;
        this.timeShow(time);
        if (this.isReturn) {
          this.$emit("update:times", time);
        }
      }, 1000);
    }
  },
  watch: {
    matchEndFlag: {
      handler(bol) {
        if (bol) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      immediate: true
    },
    times: {
      handler(val) {
        console.log("times", val);
        if (this.timerFlag) {
          // this.countDown(val)
          this.clock(val);
        } else {
          this.timeShow(val);
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="less" scoped></style>
